import { render, staticRenderFns } from "./renzhengIcon.vue?vue&type=template&id=0308632c&scoped=true"
import script from "./renzhengIcon.vue?vue&type=script&lang=js"
export * from "./renzhengIcon.vue?vue&type=script&lang=js"
import style0 from "./renzhengIcon.vue?vue&type=style&index=0&id=0308632c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308632c",
  null
  
)

export default component.exports